import { motion } from "framer-motion";
import { DB } from "@/lib/media";

const ease = [0.22, 1, 0.36, 1];

export default function About() {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="relative py-24 lg:py-32"
        >
            <div className="mx-auto max-w-[1400px] px-6 lg:px-10 grid grid-cols-12 gap-y-12 lg:gap-x-12">
                <div className="col-span-12 lg:col-span-6">
                    <motion.div
                        initial={{ opacity: 0, scale: 1.03 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 1.1, ease }}
                        className="relative overflow-hidden aspect-[5/4] bg-[#F5EFE1]"
                    >
                        <img
                            src={DB.teamAbout}
                            alt="Inside the Digitalbeej studio"
                            className="absolute inset-0 w-full h-full object-cover"
                            loading="lazy"
                        />
                        <div className="absolute top-4 left-4 text-bone text-[10px] uppercase tracking-[0.2em] font-bold mix-blend-difference">
                            The studio · Mumbai
                        </div>
                    </motion.div>
                </div>

                <div className="col-span-12 lg:col-span-6 lg:pl-8">
                    <div className="text-xs uppercase tracking-[0.22em] font-bold text-black/55">
                        (About / 04)
                    </div>

                    <motion.h2
                        data-testid="about-heading"
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.9, ease }}
                        className="mt-4 font-display font-black uppercase tracking-tight leading-[0.92] text-4xl sm:text-5xl lg:text-6xl"
                    >
                        Building brands from{" "}
                        <span className="font-serif italic font-medium normal-case lowercase text-olive">
                            seed to scale.
                        </span>
                    </motion.h2>

                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.9, ease, delay: 0.1 }}
                        className="mt-8 text-lg lg:text-xl text-black/75 leading-relaxed max-w-xl"
                    >
                        Digitalbeej is a modern creative studio that combines
                        branding, websites, AI, performance marketing and
                        commerce growth to help ambitious businesses grow with
                        clarity and purpose.
                    </motion.p>

                    {/* Capability pills */}
                    <div className="mt-10 flex flex-wrap gap-2">
                        {[
                            "Branding",
                            "Websites",
                            "AI",
                            "Performance",
                            "Commerce Growth",
                        ].map((c) => (
                            <span
                                key={c}
                                className="text-[11px] uppercase tracking-[0.16em] font-bold text-black/70 border border-black/20 px-3 py-2"
                            >
                                {c}
                            </span>
                        ))}
                    </div>

                    {/* Founder credit */}
                    <motion.div
                        data-testid="about-founder"
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.9, ease, delay: 0.2 }}
                        className="mt-12 pt-8 border-t border-black/15 flex items-start gap-5"
                    >
                        <div className="w-14 h-14 rounded-full bg-olive/15 border border-olive/40 flex items-center justify-center font-display font-black text-lg text-[#2E5019]">
                            AS
                        </div>
                        <div>
                            <div className="text-[10px] uppercase tracking-[0.22em] font-bold text-black/55">
                                Founder
                            </div>
                            <div className="mt-1 font-display font-bold text-xl tracking-tight">
                                Abhay Singh
                            </div>
                            <div className="text-sm text-black/60">
                                Founder &amp; Growth Strategist
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
